import { useTranslation } from 'react-i18next';
import { List, Text } from '@shopify/polaris';

interface HelpInfoProps {
  info: string[];
}
export const HelpInfo: React.FC<HelpInfoProps> = ({ info }) => {
  const { t } = useTranslation();

  if (!info.length) return null;

  return (
    <>
      <Text as="span" variant="bodyMd" fontWeight="semibold" tone="subdued">
        {t('Helps you')}
      </Text>
      {info.length > 1 ? (
        <List type="bullet">
          {info.map((item) => (
            <List.Item key={item}>
              <Text as="span" variant="bodyMd" tone="subdued">
                {item}
              </Text>
            </List.Item>
          ))}
        </List>
      ) : (
        <Text as="span" variant="bodyMd" tone="subdued">
          {info[0]}
        </Text>
      )}
    </>
  );
};
